<template>
    <div>
        <b-modal
        id="ImprovementCreate"
        size="md"
        title="Criar Solicitação"
        hide-footer>
            <b-overlay :show="loading">
                <form @submit.prevent="submit">
                    <b-form-group
                        label="Título"
                        >
                        <b-form-input
                        v-model="form.title"
                        placeholder="título da solicitação"
                        :state="hasErrors('title', errors)"
                        ></b-form-input>
                        <has-errors :errors="errors" name="title" />
                    </b-form-group>

                    <b-form-group
                        label="Tipo"
                    >
                        <select class="form-select" aria-placeholder="Tipo da solicitação" v-model="form.type">
                            <option value="" selected disabled>
                                Tipo da solicitação
                            </option>
                            <option v-for="(value, name, index) in categorys" :key="index" :value="name">
                                {{ value }}
                            </option>
                        </select>
                        <has-errors :errors="errors" name="type" />
                    </b-form-group>
                    <b-form-group

                        label="Descrição"
                        >
                        <b-form-textarea
                        v-model="form.description"
                        placeholder="descreva aqui as informações da solicitação..."
                        rows="3"
                        
                        max-rows="6"
                        :state="hasErrors('description', errors)"
                        ></b-form-textarea>

                        <has-errors :errors="errors" name="description" />
                    </b-form-group>
                    <b-button :disabled="isSubmiting" type="submit" variant="primary">Criar</b-button>
                </form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    data(){
        return {
            loading: false,
            isSubmiting: false,
            form: {
                title: '',
                type: '',
                description: '',
            },
            errors: {},
            categorys: null
        }
    },
    created() {
        this.$root.$on('ImprovementCreate', () => {
            this.$bvModal.show('ImprovementCreate')
        });
        this.load();
    },
    methods: {
        load(){
            this.loading = true;
            axios.get('/teacher/sleekplan/category')
            .then((result) => {
                const response = result.data.data[0]
                this.categorys = response;


            }).catch((err) => {

            })
            .finally( ()=>{
                this.loading = false
            })
        },
        submit(){
            this.isSubmiting = true
            axios.post('/teacher/post', {
                title: this.form.title,
                type: this.form.type,
                description: this.form.description
            })
            .then((result) => {
                // Close Modal
                this.$emit('created');
                this.$bvModal.hide('ImprovementCreate');

                // Message
                this.$toast.success('Solicitação Criada com Sucesso')
            }).catch((errors) => {
                this.errors = this.setErrors(errors)
            })
            .finally( ()=>{
                this.isSubmiting =false
            })
        }
    },
}
</script>

<style>

</style>
